import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AlertaSonoroService {

  private ativouAlertaSonoroSubject = new BehaviorSubject<boolean>(null);
  private somEspecificoAtivadoSubject = new BehaviorSubject<{ [key: string]: boolean }>({});

  constructor() { }


  getAtivouAlertaSonoro() {
    return this.ativouAlertaSonoroSubject.asObservable();
  }

  setAtivouAlertaSonoro(ativouAlertaSonoro: boolean) {
    this.ativouAlertaSonoroSubject.next(ativouAlertaSonoro);
  }

  
  setSomEspecificoAtivado(tipo: string, estado: boolean) {
    const atual = this.somEspecificoAtivadoSubject.getValue();
    atual[tipo] = estado;
    this.somEspecificoAtivadoSubject.next(atual);
  }

  isSomEspecificoAtivado(tipo: string): boolean {
	const somEspecifico = this.somEspecificoAtivadoSubject.getValue()[tipo];
	return somEspecifico !== undefined ? somEspecifico : true;
  }

  getSomEspecificoAtivado() {
    return this.somEspecificoAtivadoSubject.asObservable();
  }
}
